<div class="modal-header">
  <h4 class="modal-title">Issue a new employee card</h4>
</div>
<div class="modal-body">
  @if (checkingCards()) {
    <app-loader [loadingText]="'Checking available cards...'"></app-loader>
  } @else {
    @if (hasAvailableCards()) {
      <p>Select an employee from the list below, and click continue.</p>
      <app-employee-select-single (selectionChanged)="getSelectedEmployee($event)"></app-employee-select-single>
    } @else {
      <app-no-cards-available-display [displaySmaller]="true"></app-no-cards-available-display>
    }
  }
</div>

<div class="modal-footer">
  <button
    id="modalCancelBtn"
    class="btn btn-outline-dark"
    [attr.aria-label]="hasAvailableCards() ? 'Cancel' : 'Close'"
    (click)="onCancel()">
    {{ hasAvailableCards() ? 'Cancel' : 'Close' }}
  </button>
  @if (hasAvailableCards()) {
    <button
      id="modalAcceptBtn"
      class="btn btn-primary"
      type="submit"
      [disabled]="!selectedEmployeeId"
      (click)="onAccept()">
      Continue
    </button>
  }
</div>
